import baseAPI from '@/http'

const router = 'api/municipio/membro'

export const memberAPI = {
  create: (member) => baseAPI.post(`${router}/cadastrar-membro`, member),
  update: (member) => baseAPI.put(`${router}/atualizar-membro`, member),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  list: () => baseAPI.get(router),
  get: (cpf) => baseAPI.get(`${router + '/get-membro'}/${cpf}`),
  getMembers: (id) => baseAPI.get(`${router + '/get-membro-by-grupo'}/${id}`),
  getMembersByCity: (id) => baseAPI.get(`${router + '/get-membro-by-municipio'}/${id}`),
  getMembersByName: (nome) => baseAPI.get(`${router + '/get-membros-by-nome'}/${nome}`),
  deleteAnexoById: id => baseAPI.post(`/api/arquivo/anexo/excluir-relatorio-anexo/${id}`),
  updateImagemMembro: (val) => baseAPI.put(`${router}/atualizar-foto-membro`, val),

}
